
import { Component, inject, OnInit, DOCUMENT } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { APP_SETTINGS } from "../../app.settings";

@Component({
    selector: "app-gdpr",
    template: `
        <h3 class="display-3 text-center">GDPR / SIR</h3>
    `,
    standalone: false
})
export class GDPRComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private document = inject<Document>(DOCUMENT);
    private readonly env = inject(APP_SETTINGS);

    ngOnInit(): void {
        const token = this.route.snapshot.params["token"];
        this.sendToken(token);
    }

    private sendToken(token: string|null) {
        const baseUrl = this.env.gdprUrl;

        if (!token || token.length == 0) {
            this.document.location.href = baseUrl;
        }
        else {
            const url = baseUrl + "/sir?token="+token;
            this.document.location.href = url;
        }
    }

}
